import { Pipe, PipeTransform } from '@angular/core';
import { UserPreferencesService } from '@shared/services/user-preferences.service';

@Pipe({
  name: 'convertUnitLabel' // Pipe name
})
export class ConvertUnitLabelPipe implements PipeTransform {

  constructor(
    private userPreference: UserPreferencesService) {
  }

  transform(
    unitType: string
  ): string {
    return this.userPreference.getUnitNameByPreference(unitType);
  }

}
